/**
 * @generated SignedSource<<e366201d8454b04c3a621776df2d86f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbleShare_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSocialShareEmail_user">;
  readonly " $fragmentType": "PdpRespIconBubbleShare_user";
};
export type PdpRespIconBubbleShare_user$key = {
  readonly " $data"?: PdpRespIconBubbleShare_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbleShare_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialShareEmail_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "93c85ac652947769c71d3e69bebfcd4c";

export default node;
